<template>
  <div class="createstask" @click="addoperatorflge = false">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item @click="godashboards" class="needGo">
        {{ $t('route.robot') }}
      </el-breadcrumb-item>
      <el-breadcrumb-item @click="gotorobotsn" class="needGo">
        {{ $t('robot.detail') }}
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('creted.cjdsrw') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>{{ $t('creted.cjdsrw') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <div class="createdtop">创建任务</div> -->
    <div class="contentWrapper robotDetail">
      <div class="">
        {{ $t('disinfect.room') }}:
      </div>
      <div class="Uniformmargmintop">
        <el-cascader v-model="value" :options="options" @change="handleChange" size="mini" style="width: 300px;" />
      </div>
      <div class="Uniformmargtop" v-show="roomsobj.roomid">
        {{ $t('disinfect.pattern') }}:
      </div>
      <div class="Uniformmargmintop" v-show="roomsobj.roomid">
        <el-radio v-model="radio1" label="deploy_disinfect" v-show="roomsobj.mapnamas">
          {{ $t('disinfect.existingMap') }}
        </el-radio>
        <el-radio v-model="radio1" label="explore_disinfect">
          {{ $t('creted.zztansuo') }}
        </el-radio>
        <!-- <el-radio v-model="radio1" label="explore_disinfect">自主探索</el-radio> -->
      </div>
      <div class="Uniformmargtop" v-show="radio1">
        {{ $t('user.operator') }}
      </div>
      <div class="addlistoperator" v-show="radio1" @click.stop="addoperatorflge = !addoperatorflge">
        {{ operatorname }}
        <img class="opertorimages" :class="{
          arrowTransform: addoperatorflge,
          arrowTransformReturn: !addoperatorflge
        }" src="@/assets/images/robot/xiala.png">
        <div class="addoperator" v-show="addoperatorflge">
          <div class="modoals">
            <div class="boxdiv" v-for="(ele, index) in opertorlist" :key="index" :style="{
              color: ele.negative != 1 ? (ele.username == operatorname || ele.email == operatorname ? '#1890FF' : '') : 'rgba(0,0,0,0.2)',
              cursor: ele.negative != 1 ? '' : 'no-drop'
            }" @click.stop="setusernames(ele)">
              {{ ele.username == '' ? ele.email : ele.username }}
            </div>
          </div>
          <div class="addbtn" @click="opeatorfalge = true" v-show="store.state.user.authority == 1">
            + {{ $t('user.adduser') }}
          </div>
        </div>
      </div>
      <div class="Uniformmargtop" v-show="radio1 === 'explore_disinfect'">
        {{ $t('creted.ddxssj') }}:
      </div>
      <div class="Uniformmargmintop" v-show="radio1 === 'explore_disinfect'">
        <div class="timesclass" @click="killtrue">
          {{ exploresion }}
        </div>
        <Killtime ref="Killtimes" @timesvaluedurion="timesvaluedurion" />
      </div>

      <div class="Uniformmargtop" v-show="radio1 === 'deploy_disinfect' && getflooron">
        梯控楼层:
      </div>
      <div class="Uniformmargmintop" v-show="radio1 === 'deploy_disinfect' && getflooron">
        <el-select v-model="getfloor" placeholder="1" size="mini" @change="setfloorcs" style="width:300px">
          <el-option v-for="item in getfloorarray" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <!-- 安全检测，门禁和PIR -->
      <div class="Uniformmargtop" v-show="radio1">
        {{ $t('creted.aqjc') }}:
      </div>
      <div class="Uniformmargmintop" v-show="radio1">
        <el-checkbox v-model="checked1" :disabled="mjpDisabled">
          {{ $t('creted.mjp') }}
        </el-checkbox>
        <el-checkbox v-model="checked2">
          PIR
        </el-checkbox>
      </div>
      <!-- 导航中是否开启UV灯 -->
      <div class="Uniformmargtop" v-show="radio1 && radio1 !== 'disinfect'">
        {{ $t('creted.openuv') }}:
      </div>
      <div class="Uniformmargmintop" v-show="radio1 && radio1 !== 'disinfect'">
        <el-radio v-model="mode" :label="1">
          {{ $t('creted.openuvOn') }}
        </el-radio>
        <el-radio v-model="mode" :label="2">
          {{ $t('creted.openuvOff') }}
        </el-radio>
        <div :style="{ color: 'red', 'margin-top': '6px' }">
          {{ $t('creted.openuvwarning') }}
        </div>
      </div>
      <!-- 倒计时 -->
      <div class="Uniformmargtop" v-show="radio1">
        {{ $t('robot.countdown') }}:
      </div>
      <div class="Uniformmargmintop" v-show="radio1">
        <el-select v-model="countdown" placeholder="20s" size="mini" @change="countselet" style="width:300px">
          <el-option v-for="item in selectcountdown" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <!-- 被动暂停后自动结束时间 -->
      <div class="Uniformmargtop" v-show="radio1">
        {{ $t('creted.bdzthf') }}:
      </div>
      <div class="Uniformmargmintop" v-show="radio1">
        <el-select v-model="Theinvasion" placeholder="20s" size="mini" @change="Theinvasionselet" style="width:300px">
          <el-option v-for="item in selectTheinvasion" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <!-- 任务类型,单次任务和重复任务 -->
      <div class="Uniformmargtop" v-show="radio1">
        {{ $t('creted.rwlx') }}:
      </div>
      <div class="Uniformmargmintop" v-show="radio1">
        <el-radio v-model="radio2" label="once">
          {{ $t('creted.dcrw') }}
        </el-radio>
        <el-radio v-model="radio2" label="week">
          {{ $t('creted.cfrw') }}
        </el-radio>
      </div>
      <div class="Uniformmargtop" v-show="radio1">
        {{ radio2 === 'once' ? $t('creted.xzrq') : $t('creted.cfgh') }}
      </div>
      <div v-show="radio1 && radio2 === 'once'" class="Uniformmargmintop">
        <el-date-picker v-model="value1" size="mini" type="date" :clearable="false" :editable="false"
          @change="getnedatefn" style="width:300px" />
      </div>
      <div v-show="radio1 && radio2 != 'once'" class="Uniformmargmintop">
        <el-select v-model="Datevalue1" size="mini" multiple :placeholder="$t('creted.qxzcfsj')" @change="selectdata"
          style="width:300px">
          <el-option v-for="item in AlternativeDate" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="Uniformmargtop" v-show="radio1">
        {{ radio2 === 'once' ? $t('creted.xzsj') : $t('creted.cfsj') }}
      </div>
      <div v-show="radio1" class="Uniformmargmintop">
        <el-time-picker v-model="value2" size="mini" :clearable="false" :editable="false" @change="getfenzhongfn"
          style="width:300px" />
      </div>
      <!-- 创建任务按钮 -->
      <div class="Uniformmargtop" v-show="radio1">
        <el-button type="primary" @click="stabilization(newtasks)" @keyup.space.prevent.native
          @keydown.enter.prevent.native>
          {{ $t('creted.cj') }}
        </el-button>
      </div>
    </div>
    <!-- 新增操作人弹窗 -->
    <el-dialog :title="$t('user.adduser')" v-model="opeatorfalge" custom-class="oneUser" @close="cancelDialog">
      <div>
        <el-input v-model="addopeatorsname" :placeholder="$t('system.password.pleaseEnter')" />
      </div>
      <div :style="{ margin: '10px 0', color: 'rgba(0,0,0,0.4)' }">
        {{ $t('user.createrdoperatoruser') }}
      </div>
      <div :style="{ textAlign: 'right' }">
        <el-button @keyup.space.prevent.native @keydown.enter.prevent.native @click="cancelDialog">
          {{ $t('system.cancel') }}
        </el-button>
        <el-button type="primary" @click="addUseropertaor" @keyup.space.prevent.native @keydown.enter.prevent.native>
          {{ $t('system.determine') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { reactive, ref, toRefs, defineComponent, onMounted, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { regionList, deletetaskrw, createTasks, Operationtasks, newroomlist, robotelevator } from '@/apis/region';
import { getRobotDetail } from '@/apis/robot';
import { useStore } from '@/store';
import { getAllUser, addUser } from '@/apis/user';
import Killtime from '@/components/killtime/index.vue';
import i18n from '@/locales';
import Moment from 'moment';
import { ElMessage } from 'element-plus';
import { debounce } from 'lodash';
// const newdate = new  Date()
interface timingfaces {
  paramshttp?: Object
  //定义点击房间后传递的字段为对象
  roomsobj: any
  options: Array<any>
  radio1: String
  checked1: Boolean // 门禁牌是否勾选
  mjpDisabled: Boolean // 门禁牌是否禁用
  checked2: Boolean // PIR是否勾选
  countdown: any
  Theinvasion: any
  selectcountdown: Array<String>
  selectTheinvasion: Array<String>
  explorelist: Array<String>
  num: Number
  explonum: number
  radio2: String
  value1: any
  value2: any
  Datevalue1: Array<any>
  sn: any
  weekdays: Array<String>
  exploresion: string | number
  getfloor: number
  getfloorarray: Array<number>
  getflooron: boolean
  mode: number
  addoperatorflge: boolean
  operatorname: any
  opertorlist: Array<any>
  opeatorfalge: boolean
  addopeatorsname: string
}
export default defineComponent({
  components: {
    Killtime
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const timingstates: timingfaces = reactive({
      sn: route.params.sn,
      paramshttp: {
        page: 1,
        pageSize: 100,
        limit: true,
        areaName: ''
      },
      value: [],
      options: [],
      roomsobj: {},
      radio1: '',
      checked1: true,
      mjpDisabled: false, // 门禁牌是否禁用
      checked2: true,
      Datevalue1: [],
      AlternativeDate: [
        {
          value: '0',
          label: i18n.global.t('creted.zhouri')
        },
        {
          value: '1',
          label: i18n.global.t('creted.zhouyi')
        },
        {
          value: '2',
          label: i18n.global.t('creted.zhouer')
        },
        {
          value: '3',
          label: i18n.global.t('creted.zhousan')
        },
        {
          value: '4',
          label: i18n.global.t('creted.zhousi')
        },
        {
          value: '5',
          label: i18n.global.t('creted.zhouwu')
        },
        {
          value: '6',
          label: i18n.global.t('creted.zhouliu')
        }
      ],
      selectcountdown: ['5s', '10s', '15s', '20s', '25s', '30s'],//倒计时选项
      countdown: '20s',
      selectTheinvasion: ['1min', '3min', '5min', '10min'],
      explorelist: ['30s', '1min', '2min', '3min', '5min'],
      exploresion: '',
      Theinvasion: '5min',
      num: 5,
      explonum: 60,
      radio2: 'once',
      value2: new Date(new Date().setHours(new Date().getHours() + 1)),
      value1: new Date(new Date().setHours(new Date().getHours() + 1)),
      weekdays: [],
      getfloor: 1,
      getfloorarray: [],
      getflooron: true,
      mode: 1,
      addoperatorflge: false,
      opertorlist: [],
      operatorname: store.state.user.name,
      opeatorfalge: false,
      addopeatorsname: ''
      // Gotothetop() {
      //     router.go(-1)
      // }
    });
    const methods = reactive({
      // 获取操作人列表
      getusers() {
        getAllUser({
          userName: '',
          authority: '',
          negative: '',
          pageSize: 1000,
          page: 1
        }).then((res: any) => {
          console.log(res);
          timingstates.opertorlist = res.data.lists;
        });
      },
      // 获取机器人状态
      getRobotStatus() {
        const params = {
          sn: timingstates.sn
        };
        getRobotDetail(params).then((res) => {
          if (res.code == 200) {
            if (res.data.door_sensor && res.data.door_sensor.status == 'connected') {
              // 门禁牌连接，启用门禁牌
              timingstates.mjpDisabled = false;
              timingstates.checked1 = true; // 不禁用则默认勾选 
            } else {
              // 门禁牌未连接，禁用门禁牌
              timingstates.mjpDisabled = true;
              timingstates.checked1 = false; // 禁用则默认不勾选
            }
          }
        });
      },
      // 新增操作人按钮确认
      addUseropertaor() {
        if (timingstates.addopeatorsname.length < 3 || timingstates.addopeatorsname.length > 20) {
          // 提示用户名长度不能小于3位，不能大于20位
          ElMessage({
            message: i18n.global.t('user.usernameRule2'),
            type: 'error'
          });
          return;
        }
        // 新增操作人
        addUser({ username: timingstates.addopeatorsname, password: '123456' }).then((res: any) => {
          console.log(res);
          if (res.code == 200) {
            timingstates.opeatorfalge = false;
            timingstates.operatorname = timingstates.addopeatorsname;
            timingstates.addopeatorsname = '';
            methods.getusers();
            ElMessage({
              message: i18n.global.t('system.createSuccess'),
              type: 'success'
            });
          } else if (res.code == 100013) {
            // 提示用户名重复
            ElMessage({
              message: i18n.global.t('user.repeatUser'),
              type: 'error'
            });
          }
        });
      },
      // 取消新增操作人
      cancelDialog() {
        timingstates.opeatorfalge = false;
        timingstates.addopeatorsname = '';
      },
      // 点击后设置操作人
      setusernames(ele: any) {
        if (ele.negative == 1) {
          return;
        }
        timingstates.operatorname = ele.username == '' ? ele.email : ele.username;
        timingstates.addoperatorflge = false;
      },
      getelevator(ele: string) {
        robotelevator({
          sn: timingstates.sn,
          name: ele
        }).then((res: any) => {
          console.log(res.data);
          const ress = res.data;
          if (ele === 'ele_floor') {
            methods.getfloorsmax(Number(ress.content.value));
          } else {
            timingstates.getflooron = ress.content.value === 'on' ? true : false;
          }
        });
      },
      godashboards() {
        router.push('/dashboard');
      },
      gotorobotsn() {
        router.push('/robot/robotInfo/' + timingstates.sn);
      },
      killtrue(): void {
        Killtimes.value.timeflage = true;
      },
      timesvaluedurion(value1: number, value2: number) {
        timingstates.explonum = value1 * 60 + value2;
        timingstates.exploresion = value1 + 'min' + value2 + 'S';
        console.log(timingstates.explonum);
      },
      //  getchecked1falge():void {
      //      getmjpmac({
      //        sn:route.params.sn,
      //        option:'connected'
      //      }).then((res:any)=>{
      //        if (JSON.parse(res.data)[0].mac === '') {
      //           timingstates.checked1falge = true
      //           timingstates.checked1 = false
      //        }
      //      })
      // },
      // 获取区域及区域下的所有房间 手动添加上value 和label字段
      getquyus: (): void => {
        regionList(timingstates.paramshttp).then((res: any) => {
          console.log(res.data.lists);
          timingstates['options'] = res.data.lists;
          timingstates['options'].forEach((ele: any, index: number) => {
            timingstates['options'][index].value = timingstates['options'][index].ID;
            timingstates['options'][index].label = timingstates['options'][index].area_name;
            // roomList({
            //   page: 1,
            //   pageSize: 100,
            //   limit: true,
            //   roomName: "",
            //   areaid: timingstates["options"][index].ID,
            // }).then((ress: any) => {
            //   console.log(ress);
            //   timingstates["options"][index]["children"] = [];
            //   if (ress.data.lists.length > 0) {
            //     ress.data.lists.forEach((eless: any, indexs: number) => {
            //       timingstates["options"][index]["children"][indexs] = eless;
            //       timingstates["options"][index]["children"][indexs].label =
            //         eless.RoomName;
            //       timingstates["options"][index]["children"][indexs].value = {
            //         roomid: eless.ID,
            //         areaid: eless.AreaID,
            //       };
            //     });
            //   }
            newroomlist({
              page: 1,
              pageSize: 100,
              sn: timingstates.sn,
              areaid: timingstates['options'][index].ID
            }).then((ress: any) => {
              console.log(ress.data);
              timingstates['options'][index]['children'] = [];
              if (ress.data.content.list.length > 0) {
                ress.data.content.list.forEach((eless: any, indexs: number) => {
                  timingstates['options'][index]['children'][indexs] = eless;
                  timingstates['options'][index]['children'][indexs].label = eless.name;
                  timingstates['options'][index]['children'][indexs].value = {
                    roomid: eless.area_id === 0 ? eless.id : eless.yun_id,
                    areaid: eless.area_id,
                    mapnamas: eless.map
                  };
                });
              }
            });
          });
        });
      },
      // 点击切换倒计时
      countselet: (values: string) => {
        console.log(values);
        timingstates.countdown = values;
      },
      // 点击切换探索模式下时间
      exploresionselet: (explorevalue: string) => {
        console.log(explorevalue);
        if (parseInt(explorevalue) != 30) {
          timingstates.explonum = parseInt(explorevalue) * 60;
        } else {
          timingstates.explonum = parseInt(explorevalue);
        }
      },
      Theinvasionselet: (values: string) => {
        console.log(values);
        timingstates.Theinvasion = values;
      },
      // 选择房间后判断
      handleChange: (value: any): void => {
        console.log(value);
        // states .roomsobj  = {ajda:1}
        if (!value[1]) {
          ElMessage({
            message: i18n.global.t('disinfect.dqmyfj')
          });
        } else {
          timingstates.roomsobj = value[1];
        }
      },
      // raiofn: (vlues) => {
      //   console.log(vlues, states.radio1);
      // },
      getnedatefn: (getriqi: any): void => {
        console.log(getriqi, Moment(getriqi).format('YYYY-MM-DD'));
        timingstates.value1 = getriqi;
      },
      getfenzhongfn: (getriqi: any): void => {
        console.log(getriqi, Moment(getriqi).format('HH:mm:ss'));
        timingstates.value2 = getriqi;
      },
      selectdata: (values: any) => {
        console.log(values);
        timingstates.weekdays = values;
      },
      stabilization: debounce((Needtooffer) => Needtooffer(), 2000, { leading: true, trailing: false }),

      // 创建任务
      newtasks: () => {
        if (timingstates.radio2 != 'once' && timingstates.weekdays.length <= 0) {
          ElMessage({
            message: i18n.global.t('creted.qxzcfsj')
          });
          return;
        }
        const restask: Object = {
          mode: timingstates.mode,
          area_id: timingstates.roomsobj.areaid,
          auto_finish: parseInt(timingstates.Theinvasion) * 60,
          countdown: parseInt(timingstates.countdown),
          cycle: timingstates.radio2,
          days: timingstates.radio2 === 'once' ? [] : Array.from(timingstates.weekdays),
          duration: timingstates.radio1 === 'explore_disinfect' ? timingstates.explonum : null,
          flags: (timingstates.checked1 ? 1 : 0) | (timingstates.checked2 ? 2 : 0),
          map_name: timingstates.radio1 === 'deploy_disinfect' ? timingstates.roomsobj.mapnamas : '',
          room_id: timingstates.roomsobj.roomid,
          type: timingstates.radio1,
          time: Moment(timingstates.value2).format('HH:mm:ss'),
          date: timingstates.radio2 === 'once' ? Moment(timingstates.value1).format('YYYY-MM-DD') : Moment(new Date(new Date().setHours(new Date().getHours() + 1))).format('YYYY-MM-DD'),
          destination: String(timingstates.getfloor),
          operator: timingstates.operatorname
        };
        console.log(restask);
        // 创建定时任务
        createTasks(route.params.sn, restask).then((res: any) => {
          // console.log(res)
          if (res.code === 200) {
            // 开始任务
            Operationtasks(res.data.taskid, 'start', timingstates.sn, {})
              .then((ress: any) => {
                //  console.log(ress)
                if (JSON.parse(ress.data).content.code === 0) {
                  // 创建成功，正在跳转
                  ElMessage({
                    message: i18n.global.t('creted.cjcgzztz'),
                    type: 'success'
                  });
                  router.replace(`/robot/robotInfo/${route.params.sn}`);
                } else if (JSON.parse(ress.data).content.code === 11010031) {
                  // 门禁牌未连接，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.mjpwljcjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010023) {
                  // 当前有进行任务，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.dqyjxrw')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010028) {
                  // 系统内部错误，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.xtlbcwcjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010032) {
                  // 设备故障，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.sbgzcjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010030) {
                  // 机器人急停，请拔出急停按钮，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.jqjtqbcan')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010033) {
                  // 地磁磁场异常，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.dcyccjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010034) {
                  // 防撞条异常，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.fztyccjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010035) {
                  // 底盘电机过流或温度过高,创建失败
                  ElMessage({
                    message: i18n.global.t('creted.dpdjglcjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010036) {
                  // 诊断异常，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.zdyccjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010037) {
                  // 桩充中，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.zczcjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010038) {
                  // 线充中，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.xczcjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010042) {
                  // 当前地图不存在，无法创建
                  ElMessage({
                    message: i18n.global.t('creted.dqdtbczwfcj')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010045) {
                  // 导航模块运行中，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.dhmkyxzcjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010046) {
                  // 传感器异常，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.cgqyccjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010048) {
                  // 机器人温度过高，创建失败
                  ElMessage({
                    message: i18n.global.t('creted.jqrwdggcjsb')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010049) {
                  // 机器人电量小于10%，无法创建
                  ElMessage({
                    message: i18n.global.t('creted.jqrdlxy')
                  });
                  deletetaskrw(res.data.taskid, {});
                } else if (JSON.parse(ress.data).content.code === 11010040) {
                  // 与已有定时任务时间冲突，创建失败
                  deletetaskrw(res.data.taskid, {});
                  ElMessage({
                    message: i18n.global.t('dsrw.rwsjct')
                  });
                } else if (JSON.parse(ress.data).content.code === 11010041) {
                  // 任务时间已过期，创建失败
                  deletetaskrw(res.data.taskid, {});
                  ElMessage({
                    message: i18n.global.t('dsrw.rwjgq')
                  });
                } else if (JSON.parse(ress.data).content.code === 11010014) {
                  // 创建失败
                  deletetaskrw(res.data.taskid, {});
                  ElMessage({
                    message: i18n.global.t('dsrw.cjsb')
                  });
                } else {
                  deletetaskrw(res.data.taskid, {});
                }
              })
              .catch((err: any) => {
                deletetaskrw(res.data.taskid, {});
              });
          }
        });
      },
      getfloorsmax(valsa: number) {
        for (let i = 1; i <= valsa; i++) {
          timingstates.getfloorarray.push(i);
        }
      },
      setfloorcs(values: number) {
        timingstates.getfloor = values;
        console.log(timingstates.getfloor);
      }
    });

    const Killtimes = ref<any | HTMLElement>(null);
    onMounted(() => {
      //调用区域
      methods.getquyus();
      methods.getelevator('elevator');
      methods.getelevator('ele_floor');
      methods.getusers();
      methods.getRobotStatus();
      // methods.getchecked1falge()
      //   let t = methods.createTimeStr(new Date(), 'ymd') + ' 00:03:00'
      // timingstates.value2 = new Date(new Date().setHours(new Date().getHours() + 1));
      // timingstates.value2 = new Date(2016, 9, 10, 18, 40)
      // timingstates.value1 = new Date(new Date().setHours(new Date().getHours() + 1))
      nextTick(() => {
        // console.log(Killtimes.value.timeflage)
        timingstates.explonum = Killtimes.value.overindex * 60 + Killtimes.value.overmiaoindex;
        timingstates.exploresion = Killtimes.value.overindex + 'min' + Killtimes.value.overmiaoindex + 'S';
      });
    });
    return {
      ...toRefs(timingstates),
      ...toRefs(methods),
      debounce,
      store,
      Killtimes
    };
  }
});
</script>
<style lang="scss" scoped>
.robotDetail {
  position: relative;
  min-height: 50px;
  max-height: 100%;
  padding-left: 340px;
  font-size: 12px;

  .Uniformmargtop {
    margin-top: 25px;
  }

  .Uniformmargmintop {
    margin-top: 10px;

    .timesclass {
      height: 30px;
      line-height: 30px;
      width: 300px;
      padding-left: 15px;
      color: #606266;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
    }
  }
}

.createstask {
  ::v-deep(.needGo) {
    span {
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
    }
  }
}

.addlistoperator {
  width: 300px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  text-indent: 15px;
  position: relative;
  cursor: pointer;

  .opertorimages {
    width: 14px;
    height: 14px;
    right: 16px;
    top: 7px;
    position: absolute;
  }

  .addoperator {
    width: 300px;
    position: absolute;
    top: 30px;
    z-index: 9999;
    border: 1px solid #dcdfe6;
    background: #fff;

    .modoals {
      max-height: 200px;
      overflow-y: auto;
      border-radius: 4px;
      z-index: 9999;

      .boxdiv {
        height: 36px;
        line-height: 36px;
      }
    }

    .addbtn {
      height: 36px;
      line-height: 36px;
    }
  }

  .arrowTransform {
    transition: 0.2s;
    transform-origin: center;
    transform: rotateZ(-180deg);
  }

  .arrowTransformReturn {
    transition: 0.2s;
    transform-origin: center;
    transform: rotateZ(0deg);
  }
}
</style>
